export class GraphModel {
  dateTime: Date;
  value: number;
}
